<template>
    <v-container>
            <v-toolbar dense>
                <a :href="`/radiation/UpdateRadiation/${radiationId}`" ><v-icon aria-hidden="false">mdi-arrow-left</v-icon></a>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="printSection">
                    <v-icon aria-hidden="false">mdi-printer-pos</v-icon>
                    Print
                </v-btn>
            </v-toolbar>
            <br/>
            <v-flex xs12>
                <div id="printSection">
                    <v-card >
                        <v-card-title><strong>Radiation</strong></v-card-title>
                        <v-card-text class="text-left">
                            <v-row>
                                <v-col cols="4" ><strong>Building: </strong>{{radiation.building}}</v-col>
                                <v-col cols="2" ><strong>Floor: </strong>{{radiation.floor}}</v-col>
                                <v-col cols="4" ><strong>Location: </strong>{{radiation.location}}</v-col>
                                <v-col cols="2" ><strong>Has a shutter: </strong>{{radiation.hasShutter}}</v-col>        
                            </v-row>
                            <v-row>
                                <v-col cols="4" ><strong>Serial Number: </strong>{{radiation.serialNumber}}</v-col>
                                <v-col cols="4" ><strong>Isotope: </strong>{{radiation.isotopes}}</v-col>
                                <v-col cols="4" ><strong>MCI: </strong>{{radiation.mci}}</v-col>
                            </v-row>
                            <br/>
                            <br/>
                
                            <v-row>
                                <v-col cols="4"><strong>Leak: </strong>{{radiation.leak}}</v-col>
                                <v-col cols="4"><strong>Leak Test References Number: </strong>{{radiation.leakTestReferenceNumber}}</v-col>
                                <v-col cols="4"><strong>Leak Test Group: </strong>{{leakTestGroupString}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4"><strong>Holder: </strong>{{holderString}}</v-col>
                                <v-col cols="4"><strong>Holder Serial Number: </strong>{{radiation.holderSerialNumber}}</v-col>
                                <v-col cols="4"><strong>Tag: </strong>{{radiation.tag}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4"><strong>Item: </strong>{{radiation.item}}</v-col>
                                <v-col cols="4"><strong>PO: </strong>{{radiation.po}}</v-col>
                                <v-col cols="4"><strong>Source: </strong>{{radiation.source}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4"><strong>MFG: </strong>{{radiation.mfg}}</v-col>
                                <v-col cols="4"><strong>Use Building: </strong>{{radiation.useBuilding}}</v-col>
                                <v-col cols="2"><strong>Is Verified: </strong>{{radiation.isVerified}}</v-col>
                                <v-col cols="2"><strong>Is Install?: </strong>{{radiation.isInstalled}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6"><strong>Secure By Look: </strong>{{radiation.secureByLock}}</v-col>
                                <v-col cols="6"><strong>Reason Not Secure: </strong>{{radiation.reasonNotSecure}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4"><strong>Received Date: </strong>{{radiation.receivedDate}}</v-col>
                                <v-col cols="5"><strong>Update: </strong>{{radiation.updateDate}}</v-col>
                            </v-row>
                            <br/>
                            <br/>
                            <v-row>
                                <v-col cols="8">
                                <strong>Users: </strong>{{usersString}}
                            </v-col>
                            <v-col cols="4">
                                <strong>User Change: </strong>{{radiation.userChangeDate}}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                                <strong>Mailing: </strong>{{mailingString}}
                            </v-col>
                            <v-col cols="4">
                                <strong>Mailing Change: </strong>{{radiation.mailingChangeDate}}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <strong>Is Disposed: </strong>
                                    {{radiation.isDisposed}}
                            </v-col>
                            <v-col cols="3">
                                <strong>Dispose Date: </strong>
                                {{radiation.disposeDate}}
                            </v-col>
                            <v-col cols="4">
                                <strong>Dispose Site: </strong>
                                {{radiation.disposeSite}}
                            </v-col>
                            <v-col cols="3">
                                <strong>Dispose MSO: </strong>
                                {{radiation.disposeMSO}}
                            </v-col>
                        </v-row>
                        <br/>
                        <br/>
                        <div  v-for="checkWorkFlow of workFlows" :key="checkWorkFlow.id">
                        <v-row>
                            <v-col cols="3">
                                <strong>Check Date: </strong>{{checkWorkFlow.checkDate}}
                            </v-col>
                            <v-col cols="6">
                                <strong>Comments: </strong>{{checkWorkFlow.comments}}
                            </v-col>
                            <v-col cols="3">
                                <strong>User: </strong>{{checkWorkFlow.userId}}
                            </v-col>
                        </v-row>
                        </div>
                        <v-row>
                            <v-col cols="8"></v-col>
                            <v-col cols="4">
                                <strong>Radiation Safety Data Base</strong>
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                </div>
        </v-flex>
    
    </v-container>
    
</template>

<script>
import radiationAPI  from '@/services/radiationservice';
import moment from 'moment';
export default {
    name: "RadiationPrint",
    props: {
     
    },
    data: function(){
        return {
            radiation:{
                building:String,
                floor:String,
                location:String,
                hasShutter: String,
                serialNumber:String,
                isotopes:String,
                mci:String,
                leak:String,
                leakTestReferenceNumber: String,
                leakTestGroup: null,
                holder: String,
                holderSerialNumber: String,
                tag: String,
                item: String,
                po:String,
                source:String,
                mfg: String,
                useBulding: String,
                isVerified: '',
                isInstalled: '',
                secureByLock: String,
                reasonNotSecure: String,
                receivedDate: Date,
                updateDate: Date,
                users:[String],
                mailing:[String],
                userChangeDate: '',
                mailingChangeDate: '',
                isDisposed:'',
                disposeDate:'',
                disposeSite: '',
                disposeMSO:''

            },
            usersString:'',
            mailingString: '',
            leakTestGroupString:'',
            holderString:'',
            workFlows:[],
            radiationId: String
        }
    }, 
    methods:{
        formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
        },
        parseDate (date) {
           
            if (!date) return null;

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        printSection(){
            this.$htmlToPaper("printSection");
        }
    },
    mounted:async function(){
        this.radiationId=this.$route.params.radiationId;
        await radiationAPI.getRadiation(this.radiationId)
        .then(response=> {
            if(response.status===200)
            {
                console.log('Response Data', response.data);
                this.radiation=response.data;
                console.log('Radiation', this.radiation);
                this.radiation.building=response.data.building.value+' - ' +response.data.building.text;
                this.radiation.floor=response.data.floor.value;
                this.radiation.hasShutter=response.data.shutt==true?'Yes':'No';
                this.radiation.isotopes=response.data.isotopes.text;

                if(this.radiation.leakTestGroup!==null){
                    this.leakTestGroupString=this.radiation.leakTestGroup.text;
                } 

                if(this.radiation.holder!==null){
                    this.holderString=this.radiation.holder.text;
                } 

                if(response.data.verified===true)
                {
                    this.radiation.isVerified='Yes';
                }else{
                    this.radiation.isVerified='No';
                }

                if(response.data.install===true)
                {
                    this.radiation.isInstalled='Yes';
                }else{
                    this.radiation.isInstalled='No';
                }

                this.radiation.users.map(user=>{
                    this.usersString=this.usersString+user.value+' - '+user.text+'; ';
                    console.log('Users: ',this.usersString);
                });
                this.radiation.mailing.map(email=>{
                    this.mailingString=this.mailingString+email.value+' - '+email.text+';   ';
                });
                
                this.radiation.receivedDate=moment(this.radiation.receivedDate).format('MM-DD-YYYY');
                this.radiation.updateDate=moment(this.radiation.updateDate).format('MM-DD-YYYY');
                this.radiation.userChangeDate=moment(this.radiation.userChangeDate).format('MM-DD-YYYY');
                this.radiation.mailingChangeDate=moment(response.data.mailingChangeDate).format('MM-DD-YYYY');

                if(response.data.disposed)
                {    
                   this.radiation.isDisposed='Yes';
                   this.radiation.disposeDate=moment(response.data.dispDate).format('MM-DD-YYYY');
                   this.radiation.disposeDate=response.data.dispSite;
                   this.radaition.disposeMSO=response.data.dispMSO;  
                }
                else {
                    this.radiation.isDisposed='No';
                }
            }
            
        })
        .catch(error=>{console.log(error)});

        await radiationAPI.getCheckWorkFlows(this.radiationId)
        .then(response=>{
            response.data.map(workFlow=>{
                this.workFlows.push(
                    {
                        id: workFlow.id, 
                        userId: workFlow.userId, 
                        checkDate: moment(workFlow.checkDate).format('MM-DD-YYYY'), 
                        comments: workFlow.comments 
                    });
            });
        })
        .catch(error=>{console.log(error)});

    }
};
</script>
